import { render, staticRenderFns } from "./SaleInvoiceForm.vue?vue&type=template&id=f20ac36e&scoped=true"
import script from "./SaleInvoiceForm.vue?vue&type=script&lang=js"
export * from "./SaleInvoiceForm.vue?vue&type=script&lang=js"
import style0 from "./SaleInvoiceForm.vue?vue&type=style&index=0&id=f20ac36e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20ac36e",
  null
  
)

export default component.exports